// export const TIPI_PERSONA = {
//   PERSONA_FISICA: { KID: -1, LABEL: "Persona Fisica"},
//   PERSONA_GIURIDICA: { KID: 0, LABEL: "Persona Giuridica"},
//   CITTADINO_STRANIERO: { KID: 1, LABEL: "Cittadino Straniero"}
// }
                      
// export const TIPI_CONFIGURAZIONI = {INTRANET:     { KID : 1},
//                                     INTERNET:     { KID : 2}}
                                    
// export const BUTTON_TABS = {LISTA_ATTESA: { KID: 1, LABEL: "LISTA D'ATTESA"},
//                             TRATTAMENTI_APERTI: { KID: 2, LABEL: "TRATTAMENTI APERTI"},
//                             STORICO: { KID: 3, LABEL: "STORICO"}}


export const COMBO = "combo";
export const NUMERO_INTERO = "numeroIntero";
export const TESTO = "testo";
export const RADIO = "radio";
export const CHECKBOX = "checkbox";
export const NUMERO_DECIMALE = "numeroDecimale"
export const NUMERO_INTERO_NEGATIVO = "numeroInteroNegativo";
export const NUMERO_DECIMALE_NEGATIVO = "numeroDecimaleNegativo"

export const TIPI_MODELLI = {
  PRENOTAZIONE: 1,
  RECALL: 2
}                            